import React from "react";

import { FaqCategoryItem } from "../../types";
import styles from "../FaqCategoryItems.module.scss";

const Answer = () => (
  <div className={styles.answer}>
    <div className={styles.head}>
      <span className={styles.icon}>A</span>
      <p className={styles.text}>
        CSVインポート時、必須項目に入力漏れがあるとエラーが発生します。CSVファイルの入力内容をご確認ください。また、既にシステム上に登録してある情報（クラス名など）とCSVファイル内の表記が一致している必要がありますのでご注意ください。
      </p>
    </div>
  </div>
);

export const BULK_STUDENT_REGISTRATION_FAQ: FaqCategoryItem = {
  id: "bulk-student-registration-faq",
  question: "生徒の一括登録でエラーが出る／うまく登録できない",
  Answer,
};
